import {
  observable,
  computed,
  action,
  toJS,
  isObservableArray,
  autorun
} from 'mobx';
import { ViewBase } from 'mutants-appfx';
import _get from 'lodash/get'
import _cloneDeep from 'lodash/cloneDeep'
import common from '../util/common'
import { env, nativeMs, localStore } from 'mutants-microfx';
import { platform } from 'mutants-util';

/**
 * @props bodyState=[{
 *  code,
 *  Quantity:state
 * }]
 * 
 * @props RetailDetail.uiState
 * {
 *  [FieldName]:state,
 * }
 */


const defaultState = {
  disable: false,
  disableTip: null,
  min: {
    value: null,
    include: true,
    tip: null
  },
  max: {
    value: null,
    include: true,
    tip: null
  },
  abs: false,
}

class Voucher extends ViewBase {
  get type() {
    return 'Voucher';
  }

  initialColumns;//明细columns
  @observable voucherDetail;//底部详情columns
  store;
  availableAmount;//剩余总金额（结算组件需要 ）

  settlementVisiable;  // 是否可以结算

  @observable bodyState = [];

  @action enableSettlement(settlementVisiable) {
    this.settlementVisiable = settlementVisiable;
  }

  @observable targetIndex = -1

  @computed get data() {
    console.log('datamodel更新:', this.store.data)
    var that = this;
    var retailDetails = this.store.data.RetailDetails.map((el) => {
      let detail = { ...el }
      if (el.IsPresent) {
        detail.badge = { text: '赠', position: 'leftTop', className: '' }
      }
      //添加 uistate
      let uiState = {};
      const keys = Object.keys(el);
      let uiUpdateState = that.bodyState.find((singleBodyState) => el.Code == singleBodyState.code) || {};
      keys.forEach((key) => {
        let computedUiState = _cloneDeep(defaultState);
        that.assign(computedUiState, uiUpdateState[key] || {})
        uiState[key] = computedUiState;
      })
      detail.uiState = uiState;
      return detail;
    })
    return retailDetails;
  }

  @computed get guide() {
    if (this.store.data) {
      const retaildetails = this.store.data.RetailDetails;
      console.log('retaildetailslength', retaildetails.length);
      console.log('guide', !isObservableArray(retaildetails));
      if (!isObservableArray(retaildetails) || !retaildetails.length) return {};
      const standrad = retaildetails[0].Idperson;
      const diff = retaildetails.find(el => el.Idperson !== standrad);
      if (!diff && standrad !== null) {
        return retaildetails[0].Person;
      }
    }
    return {};
  }

  @computed get columns() {//明细columns （对数量value大小 作出限制）
    const isReturn = common.getIsReturn(this.store.data);
    let initialColumns = _cloneDeep(this.initialColumns);

    let quantityColumn = {};
    quantityColumn = initialColumns.find(el => el.FieldName === 'Quantity');
    if (!quantityColumn) return initialColumns;
    /* 数量取值范围 控制 */
    if (!isReturn) {
      quantityColumn.minValue = 0;
    }
    /* 数量是否可以更改 控制 */
    const isModifyQuantity = common.getIsModifyQuantityAuth();
    if (!isModifyQuantity) {
      quantityColumn.quick = false;
    }
    return initialColumns;
  }

  @computed get retailDetails() {
    return this.store.data.RetailDetails;
  }

  @computed get quantityDetail() {
    let data = this.store.data;
    let returnQuantity = 0;
    let buyQuantity = 0;
    if (!data) return { returnQuantity, buyQuantity };
    let retailDetails = data.RetailDetails;
    retailDetails.forEach((el) => {
      let quantity = 0;
      if (el.Inventory.IsWeigh) {
        quantity = el.Quantity > 0 ? 1 : -1;
      } else {
        quantity = el.Quantity;
      }
      if (quantity >= 0) {
        buyQuantity = buyQuantity + Math.abs(quantity);
      } else {
        returnQuantity = returnQuantity + Math.abs(quantity);
      }
    })
    console.log('quantityDetail===', { returnQuantity, buyQuantity })
    return { returnQuantity, buyQuantity };
  }

  @computed get totalQuantity() {
    let data = this.store.data
    if (!data) return 0;
    let retailDetails = data.RetailDetails;
    let totalQuantity = 0;
    retailDetails.forEach((el) => {
      if (el.Inventory.IsWeigh) {
        totalQuantity++;
      } else {
        totalQuantity = Math.abs(el.Quantity) + totalQuantity
      }
    })
    return totalQuantity;
  }

  @computed get totalVariety() {
    let data = this.store.data
    if (!data) return 0;
    let retailDetails = data.RetailDetails;
    return new Set(retailDetails.map((retailDetail) => retailDetail.Idinventory)).size;
  }

  constructor(store, name, columns = [], voucherDetail = []) {
    super(store, name);
    this.voucherDetail = voucherDetail;
    this.initialColumns = this.createVoucherColumns(columns);
    autorun(() => {
      var data = this.store.data;
      this.setIpcRendererMethod(data);
    }, { delay: 50 });
  }

  setIpcRendererMethod(data) {
    console.time('screen sync data need time')
    if (!data) return;
    let { RetailDetails, TotalTaxAmount } = data;
    let columnNames = ["Inventory", "Quantity", "TaxPrice", "TaxAmount"]
    const retaildetails = RetailDetails.map((recode) => {
      const newRecord = {};
      columnNames.forEach((key) => {
        newRecord[key] = recode[key]
      })
      return newRecord
    })
    console.log('setIpcRendererMethod=>retaildetails', retaildetails)
    if (this.getScreenType() === true) { //副屏幕交互
      const { isHorizontalSunMi } = platform || {};
      if (RetailDetails && RetailDetails.length > 0) {
        let params = { step: 2, data: { RetailDetails: retaildetails, TotalTaxAmount } };
        if (!!isHorizontalSunMi) {
          window.sunMi_PresentationManager && window.sunMi_PresentationManager.sendMessageToSecondScreen(params);
        } else {
          nativeMs.setIpcRendererMethod('ReplyScreen', params)
        }
      } else {
        if (!!isHorizontalSunMi) {
          window.sunMi_PresentationManager && window.sunMi_PresentationManager.sendMessageToSecondScreen({ step: 1 });
        } else {
          nativeMs.setIpcRendererMethod('ReplyScreen', { step: 1 })
        }
      }
    }
    console.timeEnd('screen sync data need time')
  }

  assign(oldObj, newObj) {
    let that = this;
    const keys = Object.keys(oldObj);
    keys.forEach((key) => {
      if (typeof oldObj[key] == 'object' && oldObj[key] !== null) {
        that.assign(oldObj[key], newObj[key] || {})
      } else {
        if (key in newObj) { oldObj[key] = newObj[key] }
      }
    })
  }

  @action
  changeUiState(...update) {
    var that = this;
    update.forEach(({ code, options = {} }) => {
      let curIndex;
      let cur = that.bodyState.find((singleState, index) => {
        if (singleState.code && singleState.code == code) {
          curIndex = index;
          return true;
        }
        return false;
      });
      if (!cur) that.bodyState.push({ code, ...options });
      if (cur) {
        that.bodyState.splice(curIndex, 1, { code, ...options })
      }
    })
  }

  @action clearUiState() {
    const length = this.bodyState.length;
    this.bodyState.splice(0, length);
  }

  // 获取副屏的状态
  getScreenType = () => {
    let flag = false;
    const { isHorizontalSunMi } = platform || {};
    if (env.platform === env.constant.platform.electron || !!isHorizontalSunMi) {
      let data = localStore.get('setting_setData') || [];
      data = data.filter(item => item.Name === 'EnableDoubleScreen');
      data = data && data.length > 0 ? data.shift() : null;
      if (data && data.Value === '1') {
        flag = true;
      }
    }
    return flag;
  }

  //是否退货
  getIsTakeTheir() {
    return common.getIsTakeTheir(this.store.data)
  }

  @action
  createVoucherColumns(voucherColumns) {
    let columns = [];
    let voucherType = localStore && localStore.get("voucherDefaultPosMode") || 'touch';
    if (voucherType == 'voucher') {
      this.voucherDetail.forEach(el => {
        let realColumn = voucherColumns.find(it => it.FieldName === el.FieldName) || {};
        let propertys = el.FieldType == "number" ? { textAlign: 'right' } : { textAlign: 'left' }
        let column = {
          ...el,
          ...propertys,
          title: el.Title,
          key: el.FieldName,
          dataIndex: el.FieldName,
          precision: el.Precision,
          maxLength: el.MaxLength,
          controlType: el.ControlType,
          ...realColumn,
          width: el.Width
        }
        columns.push(column);
      })
    } else {
      voucherColumns.forEach(el => {
        let realColumn = this.voucherDetail.find((it) => it.FieldName === el.FieldName) || {};
        let column = {
          ...realColumn,
          title: realColumn.Title,
          precision: realColumn.Precision,
          maxLength: realColumn.MaxLength,
          controlType: realColumn.ControlType,
          ...el
        }
        columns.push(column);
      })
    }
    return columns;
  }

  @action setCurRow({ type, index, record }) {
    let retailDetails = this.store.data.RetailDetails;
    if (!retailDetails[index]) return;
    this.targetIndex = index;

  }

  static fromJS(store, { Voucher: voucherViewInfo }) {
    let columns = voucherViewInfo.VoucherColumns;
    let voucherDetail = voucherViewInfo.VoucherDetail;
    return new Voucher(store, 'Voucher', columns, voucherDetail)
  }
}
export default Voucher;